// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contactus-container {
    display: flex;
    width: 80%;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px; /* Added px unit */
}
.contacts-container .title{
    font-size: 40px;
  font-weight: 500;
  text-align: left;
  width: 80%;
  margin-top: 30px;
  margin-bottom: 30px;
}
.contact-form {
        display: flex;
        background-color: #262626;
        border: 1px solid #d9d9d91f;
        border-radius: 12px;
        align-items: center;
        gap: 20px; /* Added px unit */
        width: 480px; /* Added px unit */
        flex-direction: column;
        /* font-weight: 600; */
        font-size: 20px; /* Added px unit */
        padding: 20px; /* Added px unit */
    }
    .contact-group {
        display: flex;
        justify-content: space-between;
        width: 80%;
    }
    
@media only screen and (max-width: 1000px) {
    .contactus-container {
     flex-direction: column;
    }
    .contact-form {
        width: 120%;
    }
    .contact-group{
        width: 100%;
    }
    .contacts-container .title{
font-size: 40px;
    }
}

.contact-form {
    box-shadow: 0 0 15px #bebdbd1f;
}

.contact-form:hover {
    transform: scale(1.01);
    box-shadow: 0 0 15px #d9d9d91f;
}
`, "",{"version":3,"sources":["webpack://./src/pages/contactUs/contactUs.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,UAAU;IACV,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB,EAAE,kBAAkB;AAC3C;AACA;IACI,eAAe;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;AACA;QACQ,aAAa;QACb,yBAAyB;QACzB,2BAA2B;QAC3B,mBAAmB;QACnB,mBAAmB;QACnB,SAAS,EAAE,kBAAkB;QAC7B,YAAY,EAAE,kBAAkB;QAChC,sBAAsB;QACtB,sBAAsB;QACtB,eAAe,EAAE,kBAAkB;QACnC,aAAa,EAAE,kBAAkB;IACrC;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,UAAU;IACd;;AAEJ;IACI;KACC,sBAAsB;IACvB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;AACJ,eAAe;IACX;AACJ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;AAClC","sourcesContent":[".contactus-container {\n    display: flex;\n    width: 80%;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 40px; /* Added px unit */\n}\n.contacts-container .title{\n    font-size: 40px;\n  font-weight: 500;\n  text-align: left;\n  width: 80%;\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n.contact-form {\n        display: flex;\n        background-color: #262626;\n        border: 1px solid #d9d9d91f;\n        border-radius: 12px;\n        align-items: center;\n        gap: 20px; /* Added px unit */\n        width: 480px; /* Added px unit */\n        flex-direction: column;\n        /* font-weight: 600; */\n        font-size: 20px; /* Added px unit */\n        padding: 20px; /* Added px unit */\n    }\n    .contact-group {\n        display: flex;\n        justify-content: space-between;\n        width: 80%;\n    }\n    \n@media only screen and (max-width: 1000px) {\n    .contactus-container {\n     flex-direction: column;\n    }\n    .contact-form {\n        width: 120%;\n    }\n    .contact-group{\n        width: 100%;\n    }\n    .contacts-container .title{\nfont-size: 40px;\n    }\n}\n\n.contact-form {\n    box-shadow: 0 0 15px #bebdbd1f;\n}\n\n.contact-form:hover {\n    transform: scale(1.01);\n    box-shadow: 0 0 15px #d9d9d91f;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
